import { Component } from '@opten/compiler/metadata/component';
import { OnInit } from '@opten/compiler/metadata/lifecycle';
import { hasClass } from '@opten/dom/has-class';
import { showMegaDropdown, hideMegaDropdown } from '../mega-dropdown';
import { lockScrollbar, unlockScrollbar } from '../../utilities/scroll-helper';

@Component({ className: 'js-search'})
export class Search implements OnInit {
	get _isOpen(): boolean {
		return hasClass(this.element, '--show');
	}

	private _backdropElement: HTMLElement;

	constructor(private element: HTMLElement) {}

	onInit() {
		// todo: own backdrop or resuse navbar?
		this._backdropElement = document.getElementsByClassName(
			'js-search-backdrop'
		)[0] as HTMLElement;

		this._backdropElement.addEventListener('click', () => {
			console.log('click');
			// this.close();
			this.close();
		});
	}

	public toggle() {
		this._isOpen ? this.close() : this.open();
	}

	public open() {
		if (this._isOpen) {
			return;
		}

		// mostly for iOS devices
		lockScrollbar(() => {
			// show and then focus search
			showMegaDropdown(this.element, this._backdropElement, () =>
				this.element.getElementsByTagName('input')[0].focus()
			);
		});
	}

	public close() {
		if (!this._isOpen) {
			return;
		}

		// mostly for iOS devices
		unlockScrollbar();

		hideMegaDropdown(this.element, this._backdropElement);
	}
}

@Component({ className: 'js-search-desktop'})
export class SearchDesktop implements OnInit {
	get _isOpen(): boolean {
		return hasClass(this.element, '--show');
	}

	private _backdropElement: HTMLElement;

	constructor(private element: HTMLElement) {}

	onInit() {
		// todo: own backdrop or resuse navbar?
		this._backdropElement = document.getElementsByClassName(
			'js-search-backdrop'
		)[0] as HTMLElement;

		this._backdropElement.addEventListener('click', () => {
			console.log('click');
			this.close();
		});
	}

	public toggle() {
		this._isOpen ? this.close() : this.open();
	}

	public open() {
		if (this._isOpen) {
			return;
		}

		if (!this._backdropElement || this._backdropElement == undefined) {
			this._backdropElement = document.getElementsByClassName(
				'js-search-backdrop'
			)[0] as HTMLElement;
		}
		// show and then focus search
		showMegaDropdown(this.element, this._backdropElement, () =>
			this.element.getElementsByTagName('input')[0].focus()
		);
	}

	public close() {
		if (!this._isOpen) {
			return;
		}
		if (!this._backdropElement || this._backdropElement == undefined) {
			this._backdropElement = document.getElementsByClassName(
				'js-search-backdrop'
			)[0] as HTMLElement;
		}
		hideMegaDropdown(this.element, this._backdropElement);
	}
}